const getCommand = async ({ params, api }) => {
  return await api(`commands/${params.id}`)
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default getCommand;
